import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-box',
  templateUrl: './box.component.html',
})
export class BoxComponent {}
